import React from 'react';
import { Col, Form } from 'react-bootstrap';
import type { User } from '../../../types';
import type { ChangeCatalogItem } from '../../../types/changes';
import { CHANGE_FIELD_LIMITS } from '../changeValidation';

export interface ChangeScopeFilterValues {
  categoryId: string;
  project: string;
  ownerId: string;
}

export const EMPTY_SCOPE_FILTERS: ChangeScopeFilterValues = {
  categoryId: '',
  project: '',
  ownerId: '',
};

export const hasScopeFilters = (values: ChangeScopeFilterValues): boolean =>
  Boolean(values.categoryId || values.project.trim() || values.ownerId);

interface Props {
  values: ChangeScopeFilterValues;
  onChange: (patch: Partial<ChangeScopeFilterValues>) => void;
  users: User[];
  categories: ChangeCatalogItem[];
  /** Largura das colunas; a listagem e o calendário usam grids diferentes. */
  colProps?: { xs?: number; md?: number };
}

/**
 * Filtros de escopo (categoria / projeto / responsável) usados pela listagem e
 * pelo calendário, que antes mantinham cópias separadas do mesmo trio.
 */
const ChangeScopeFilters: React.FC<Props> = ({ values, onChange, users, categories, colProps }) => {
  const col = { xs: colProps?.xs ?? 6, md: colProps?.md ?? 2 };

  return (
    <>
      <Col xs={col.xs} md={col.md}>
        <Form.Select
          value={values.categoryId}
          onChange={(event) => onChange({ categoryId: event.target.value })}
          aria-label="Categoria"
        >
          <option value="">Todas as categorias</option>
          {categories.map((entry) => (
            <option key={entry.id} value={entry.id}>
              {entry.name}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={col.xs} md={col.md}>
        <Form.Control
          placeholder="Projeto"
          value={values.project}
          maxLength={CHANGE_FIELD_LIMITS.shortText}
          onChange={(event) => onChange({ project: event.target.value })}
        />
      </Col>
      <Col xs={12} md={col.md}>
        <Form.Select
          value={values.ownerId}
          onChange={(event) => onChange({ ownerId: event.target.value })}
          aria-label="Responsável"
        >
          <option value="">Todos responsáveis</option>
          {users.map((entry) => (
            <option key={entry.id} value={entry.id}>
              {entry.name}
            </option>
          ))}
        </Form.Select>
      </Col>
    </>
  );
};

export default ChangeScopeFilters;
